import accountPortalRoutes from '~/app/providers/router/accountPortalRoutes'
import { EClientPath } from '~/models/api'

const preloadAccountPortalRoutes = () => {
  accountPortalRoutes
    .find((route) => route.path === EClientPath.overview)
    ?.preload()
}

export default preloadAccountPortalRoutes
